import isMobileLib from "ismobilejs";

class DeviceService {
    static isIphone(): boolean {
        return /iPhone/.test(navigator.userAgent);
    }

    static isSafari(): boolean {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    static isMobile = () => {
        return isMobileLib(window.navigator).any;
    };
}

export default DeviceService;
